import { render, staticRenderFns } from "./LpuTypeModal.vue?vue&type=template&id=2124717c&"
import script from "./LpuTypeModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LpuTypeModal.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2124717c')) {
      api.createRecord('2124717c', component.options)
    } else {
      api.reload('2124717c', component.options)
    }
    module.hot.accept("./LpuTypeModal.vue?vue&type=template&id=2124717c&", function () {
      api.rerender('2124717c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/lpu/components/LpuTypeFilters/components/LpuTypeModal.vue"
export default component.exports